import React from "react";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

const getBackgroundColor = (errorCode) => {
  console.log(errorCode);
  if (errorCode >= 100 && errorCode < 200) {
    return "blue";
  } else if (errorCode >= 200 && errorCode < 300) {
    return "green";
  } else if (errorCode >= 300 && errorCode < 400) {
    return "yellow";
  } else if (errorCode >= 400 && errorCode < 500) {
    return "orange";
  } else if (errorCode >= 500) {
    return "red";
  } else {
    return "green";
  }
};

const CustomSnackbar = styled(Snackbar)(({ theme, errorCode }) => ({
  "& .MuiSnackbarContent-root": {
    backgroundColor: getBackgroundColor(errorCode),
    borderRadius: "8px",
  },
}));

export default function ToastComponent({
  isToastOpen,
  setIsToastOpen,
  message,
  errorCode,
  showAtBottom,
}) {
  console.log("Toast component");
  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={() => setIsToastOpen(false)}
    >
      <CloseIcon fontSize="small" sx={{ width: "24px", height: "24px" }} />
    </IconButton>
  );

  return (
    <Box sx={{ minWidth: 200, fontSize: "20px" }}>
      <CustomSnackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={isToastOpen}
        onClose={() => setIsToastOpen(false)}
        message={message}
        key={"top" + "center"}
        action={action}
        sx={
          showAtBottom
            ? {
                position: "fixed",
                bottom: "76px !important",
                left: "60% !important",
                transform: "translateX(-50%)",
              }
            : {
                position: "fixed",
                top: "-50%",
                transform: "translateY(50%)",
              }
        }
        autoHideDuration={2500}
      />
    </Box>
  );
}
